import axios from "axios";

// Declare the URL for the backend server.
const baseURL = "https://apim-p-idb-integration.iadb.org/ext/slo/api";

const authService = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "ocp-apim-subscription-key": "5e33d0d3c05a4fb096fb3c36c6f39aac",
  },
});
/**
 *
 * @param {string} url Request URL
 * @returns Request response object
 */
export async function sendRequest(url) {
  return authService
    .get(url)
    .then((response) => {
      if (response.status !== 200) return "ERROR_LOADING_DATA";
      return response;
    })
    .catch(() => {
      return "ERROR_LOADING_DATA";
    });
}
